import styled from 'styled-components';
import React from 'react';
import { Button } from '@mui/material';
import { SvgIcon } from '@cnx-saas/design-system';

const PWAInstallButton = styled(Button)`
  margin-top: 1rem;
  width: 100%;
`;

const PWAInstallLabel = styled.span`
  line-height: 18px;
  vertical-align: middle;
`;

const NavbarSvgIcon = styled(SvgIcon)<{ isSidebarOpen: boolean }>`
  height: 18px;
  margin-right: ${({ theme, isSidebarOpen }) =>
    isSidebarOpen ? theme.spacing(1.3) : theme.spacing(3.5)};
  transition: margin 0.3s ease-out;
  vertical-align: middle;
`;

const PWAInstallIcon = ({ isSidebarOpen }: { isSidebarOpen: boolean }) => (
  <NavbarSvgIcon isSidebarOpen={isSidebarOpen}>
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
  </NavbarSvgIcon>
);

export { PWAInstallButton, PWAInstallIcon, PWAInstallLabel };
